import styled from 'styled-components'

export const Container = styled.div<{
  reporte_obrigatorio?: boolean
  requer_atencao?: boolean
  size: number
}>`
  padding: 0.25;
  border-radius: 50%;
  width: ${props =>
    (props.reporte_obrigatorio ? 0.4375 : 0.35) * props.size + 1}rem;
  height: ${props =>
    (props.reporte_obrigatorio ? 0.4375 : 0.35) * props.size + 1}rem;
  color: var(--black);
  background-color: ${props =>
    props.requer_atencao ? 'var(--red)' : 'var(--grey)'};
  font-size: ${props => (props.reporte_obrigatorio ? '.7rem' : '.5rem')};
  font-weight: bold;
  text-align: center;
  > span {
    display: inline-block;
    line-height: normal;
  }
  :before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    padding-top: 100%;
  }
`
